import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import {
    IAdobeFormInteraction,
    IAdobeInteraction,
    IAdobeLinkInteraction,
    IAdobeVideoInteraction,
    InteractionType
} from "../models/adobe-analytics.model";
import { AdobeAnalyticsService } from "../services/adobe-analytics.service";

@Directive({
    selector: "[appTrackAdobe]"
})
export class AdobeAnalyticsDirective {
    @Input("appTrackAdobe") public interaction!:
        | IAdobeInteraction
        | IAdobeLinkInteraction
        | IAdobeVideoInteraction
        | IAdobeFormInteraction
        | null
        | undefined;

    @HostListener("click")
    public onClick() {
        if (this.interaction) {
            this.trackInteraction(this.interaction);
        }
    }

    @HostListener("mouseenter") public onMouseEnter() {
        this.elementRef.nativeElement.style.cursor = "pointer";
    }

    constructor(private analytics: AdobeAnalyticsService, private elementRef: ElementRef) {}

    public trackInteraction(
        interaction: IAdobeInteraction | IAdobeLinkInteraction | IAdobeVideoInteraction | IAdobeFormInteraction
    ): void {
        // Call a different function based on interaction type
        switch (interaction.type) {
            case InteractionType.Interaction:
                this.analytics.trackInteraction(interaction);
                break;
            case InteractionType.Link:
                this.analytics.trackLinkInteraction(interaction);
                break;
            case InteractionType.Video:
                this.analytics.trackVideoInteraction(interaction);
                break;
            case InteractionType.Form:
                this.analytics.trackFormInteraction(interaction);
                break;
            default:
                this.analytics.trackInteraction(interaction);
        }
    }
}
